import { render, staticRenderFns } from "./TheLibrary.vue?vue&type=template&id=8fc9e4fa&"
import script from "./TheLibrary.vue?vue&type=script&lang=js&"
export * from "./TheLibrary.vue?vue&type=script&lang=js&"
import style0 from "./TheLibrary.vue?vue&type=style&index=0&id=8fc9e4fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports